export default __webpack_public_path__ + "static/media/BIFI-USDT.007d0dc7.png";